import "../styles/css/admin-style.css";

const AdminSettingsPage = () => {
    return (
        <div className="container-fluid ptCustom">
            <div className="row">
                <div className="col-md-6 my-2">
                    <div className="card shadow-sm rounded-lg">
                        <div className="card-body p-4">
                            <div className="row mb-3">
                                <div className="col-12">
                                    <div className="mb-3">
                                        <label htmlFor="exampleSetting1" className="form-label">Example</label>
                                        <input type="text" className="form-control" id="exampleSetting1" placeholder="example setting"/>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="exampleSetting2" className="form-label">Example</label>
                                        <textarea className="form-control" id="exampleSetting2" rows={3}></textarea>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="text-end">
                                    <button type="button" className="btn btn-primary shadow-sm"><i className="fa-regular fa-save"></i> Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminSettingsPage;
